/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Sandboxshell_Releasestatus_Released2Inputs */

const id_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dirilis`)
};

const ms_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dikeluarkan`)
};

const da_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Udgivet`)
};

const de_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veröffentlicht`)
};

const en_us2_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released`)
};

const es_es2_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzado`)
};

const es_mx2_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzado`)
};

const fil_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inilabas`)
};

const fr_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorti`)
};

const it_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rilasciato`)
};

const hu_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Megjelent`)
};

const nl_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uitgebracht`)
};

const no_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Utgitt`)
};

const pl_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wydane`)
};

const pt_br2_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released`)
};

const pt_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançado`)
};

const ro_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lansat`)
};

const fi_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Julkaistu`)
};

const sv_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Släppt`)
};

const vi_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phát hành`)
};

const tr_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yayınlandı`)
};

const cs_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vydáno`)
};

const bg_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Издадено`)
};

const ru_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выпущено`)
};

const uk_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Випущено`)
};

const ar_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم الإصدار`)
};

const hi_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिलीज़ हो गया`)
};

const th_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วางจำหน่ายแล้ว`)
};

const ja_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`リリース済み`)
};

const zh_cn2_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released`)
};

const zh_hant1_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released`)
};

const ko_components_sandboxshell_releasestatus_released2 = /** @type {(inputs: Components_Sandboxshell_Releasestatus_Released2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Released`)
};

/**
* | output |
* | --- |
* | "Released" |
*
* @param {Components_Sandboxshell_Releasestatus_Released2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_sandboxshell_releasestatus_released2 = /** @type {((inputs?: Components_Sandboxshell_Releasestatus_Released2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Sandboxshell_Releasestatus_Released2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "ms") return ms_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "da") return da_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "de") return de_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "en-US") return en_us2_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "es-ES") return es_es2_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "es-MX") return es_mx2_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "fil") return fil_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "fr") return fr_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "it") return it_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "hu") return hu_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "nl") return nl_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "no") return no_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "pl") return pl_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "pt-BR") return pt_br2_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "pt") return pt_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "ro") return ro_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "fi") return fi_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "sv") return sv_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "vi") return vi_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "tr") return tr_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "cs") return cs_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "bg") return bg_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "ru") return ru_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "uk") return uk_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "ar") return ar_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "hi") return hi_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "th") return th_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "ja") return ja_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_sandboxshell_releasestatus_released2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_sandboxshell_releasestatus_released2(inputs)
	return ko_components_sandboxshell_releasestatus_released2(inputs)
});
export { components_sandboxshell_releasestatus_released2 as "components.sandboxShell.releaseStatus.released" }